import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { ParentsTable } from '@features/parents-list/components/ParentsTable'
import { parentsQueryOptions } from '@features/parents-list/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/parents/all')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(parentsQueryOptions())
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load parents'>
            <Suspense fallback={<LoadingIndicator resource='parents' />}>
                <ParentsTable />
            </Suspense>
        </QueryErrorBoundary>
    )
}
